import { types } from '../../../constants/ActionTypes'

const initialState = {
  open: false,
  image: '',
}

const downloadImageDialog = (state = initialState, action) => {
  switch (action.type) {
    case types.downloadImageDialog.OPEN:
      return { ...state, open: true, image: '' }
    case types.downloadImageDialog.CLOSE:
      return { ...state, open: false }
    case types.lib.RESPONSE_CREATE_BOARD_IMAGE:
      if (state.open === false) {
        return state
      }
      return { ...state, image: action.boardImage }
    default:
      return state
  }
}

export default downloadImageDialog



// WEBPACK FOOTER //
// ./src/reducers/Common/RenjuBoardCard/DownloadImageDialog.js